// src/pages/Contact.jsx
import React, { useState } from "react";
import Section from "../components/Section";

export default function Contact(){
  const [form,setForm]=useState({name:"",email:"",message:""});
  const onChange=e=>setForm({...form,[e.target.name]:e.target.value});
  const onSubmit=e=>{
    e.preventDefault();
    window.location.href=`mailto:austinlm132@gmail.com?subject=${encodeURIComponent("Contact from "+form.name)}&body=${encodeURIComponent(form.message+"\n\nEmail: "+form.email)}`;
  };
  return (
    <Section title="Contact" subtitle="Tell me about your vehicle and goals.">
      <form onSubmit={onSubmit} className="card" style={{padding:20,maxWidth:560}}>
        <label className="small">Name
          <input className="small" style={{display:"block",marginTop:6,width:"100%",background:"rgb(0 0 0 / .2)",border:"1px solid rgb(255 255 255 / .1)",borderRadius:10,padding:"10px 12px"}} required name="name" onChange={onChange} autoComplete="name"/>
        </label>
        <label className="small" style={{marginTop:12}}>Email
          <input className="small" style={{display:"block",marginTop:6,width:"100%",background:"rgb(0 0 0 / .2)",border:"1px solid rgb(255 255 255 / .1)",borderRadius:10,padding:"10px 12px"}} required type="email" name="email" onChange={onChange} autoComplete="email"/>
        </label>
        <label className="small" style={{marginTop:12}}>Message
          <textarea className="small" rows={5} style={{display:"block",marginTop:6,width:"100%",background:"rgb(0 0 0 / .2)",border:"1px solid rgb(255 255 255 / .1)",borderRadius:10,padding:"10px 12px"}} required name="message" onChange={onChange}/>
        </label>
        <div className="row" style={{marginTop:12}}>
          <button className="btn btn-primary" type="submit">Send</button>
          <a className="btn btn-outline" href="tel:+1-000-000-0000">Call</a>
        </div>
      </form>
    </Section>
  );
}
